import React from 'react';
import { css } from '@linaria/core';
import { useSearch } from '@elastic/react-search-ui';
import { useLayoutMode } from './Layout';
import MapView from './MapView';

const resultsContainer = css`
  display: flex;
  flex-direction: column;

  &[data-layout-mode='grid'] {
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
    margin-top: 20px;

    @media (min-width: 500px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 800px) {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  &[data-layout-mode='map'] {
    display: block;
  }
`;

const mapSearchContext = ({
  results,
  facets,
  setFilter,
  addFilter,
  removeFilter,
  filters,
  requestId,
  isLoading,
}) => ({
  results,
  facets,
  setFilter,
  addFilter,
  removeFilter,
  filters,
  requestId,
  isLoading,
});

export default function Results({ children }) {
  const { layoutMode, searchType } = useLayoutMode();
  const {
    results,
    facets,
    setFilter,
    addFilter,
    removeFilter,
    filters,
    requestId,
    isLoading,
  } = useSearch(mapSearchContext);

  if (layoutMode === 'map') {
    return (
      <MapView
        addFilter={addFilter}
        facets={facets}
        filters={filters}
        isLoading={isLoading}
        removeFilter={removeFilter}
        requestId={requestId}
        results={results || []}
        searchType={searchType}
        setFilter={setFilter}
      />
    );
  }

  return (
    <div className={resultsContainer} data-layout-mode={layoutMode}>
      {children}
    </div>
  );
}
